import type { SharedResource } from './types';

type PreviewKind = 'image' | 'doc' | 'pdf' | 'none';

type ResourcePreviewModalProps = {
  data: {
    previewResource: SharedResource | null;
    previewKind: PreviewKind;
  };
  actions: {
    onClose: () => void;
  };
};

const ResourcePreviewModal = ({
  data,
  actions,
}: ResourcePreviewModalProps) => {
  const { previewResource, previewKind } = data;
  const { onClose } = actions;
  if (!previewResource || previewKind === 'none') {
    return null;
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 p-4"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div
        className="w-full max-w-4xl overflow-hidden rounded-2xl bg-white shadow-xl"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="flex items-center justify-between border-b border-slate-100 px-4 py-3">
          <div>
            <p className="text-sm font-semibold text-slate-900">
              {previewResource.name}
            </p>
            <p className="text-xs text-slate-400">{previewResource.type}</p>
          </div>
          <button
            type="button"
            className="flex h-8 w-8 items-center justify-center rounded-full text-slate-400 hover:bg-slate-100"
            aria-label="Close preview"
            onClick={onClose}
          >
            <svg
              className="h-4 w-4"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M18 6 6 18" />
              <path d="M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="bg-slate-50 p-4">
          {previewKind === 'image' ? (
            <div className="flex items-center justify-center">
              <img
                src={previewResource.link}
                alt={previewResource.name}
                className="max-h-[70vh] w-full object-contain"
              />
            </div>
          ) : previewKind === 'pdf' ? (
            <iframe
              title={previewResource.name}
              className="h-[70vh] w-full rounded-lg bg-white"
              src={previewResource.link}
            />
          ) : (
            <iframe
              title={previewResource.name}
              className="h-[70vh] w-full rounded-lg bg-white"
              src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                previewResource.link ?? ''
              )}`}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export type { PreviewKind };
export default ResourcePreviewModal;
